import { Routes, Route } from 'react-router-dom';

import { usePageViews } from './lib/analytics.js';

import SiteHeader from './components/SiteHeader.jsx';
import SiteFooter from './components/SiteFooter.jsx';
import ManagerPage from './pages/ManagerPage.jsx';
import ArchiveManagerPage from './pages/ArchiveManagerPage.jsx';
import TickerPage from './pages/TickerPage.jsx';
import HistoryPage from './pages/HistoryPage.jsx';
import LeaguePage from './pages/LeaguePage.jsx';
import HomePage from './pages/HomePage.jsx';
import TopManagersPage from './pages/TopManagersPage.jsx';
import ArchivePage from './pages/ArchivePage.jsx';
import FdrPage from './pages/FdrPage.jsx';
import DraftPage from './pages/DraftPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import './App.css';

/*
 * Every page of the site. Flask serves this shell for any path that is not
 * an API route (see angular_flask/controllers.py), so the router below is
 * the single source of truth for what exists — including the not-found page.
 */
export default function App() {
	usePageViews();

	return (
		<div className="app-shell">
			<SiteHeader />
			<main className="app-main app-container">
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/manager" element={<ManagerPage />} />
					<Route path="/manager/:user" element={<ManagerPage />} />
					<Route
						path="/archive/:season/manager/:managerCode"
						element={<ArchiveManagerPage />}
					/>
					<Route path="/ticker" element={<TickerPage />} />
					{/* A splat: /history, /history/top-seasons and
					    /history/season/2025-26/gw-matrix all resolve in
					    pages/history/tabRoutes.js. */}
					<Route path="/history/*" element={<HistoryPage />} />
					<Route path="/league/:div" element={<LeaguePage />} />
					<Route path="/top1k" element={<TopManagersPage />} />
					<Route path="/archive" element={<ArchivePage />} />
					<Route path="/archive/:season" element={<ArchivePage />} />
					<Route path="/archive/:season/:league" element={<ArchivePage />} />
					{/* /draft builds a new squad; /draft/:slug is a published one,
					    read-only unless this browser holds its edit key. */}
					<Route path="/draft" element={<DraftPage />} />
					<Route path="/draft/:slug" element={<DraftPage />} />
					<Route path="/:user/ticker/edit" element={<FdrPage />} />
					<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</main>
			<SiteFooter />
		</div>
	);
}
